import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service, DropdownData } from '@zayan-erp/shared';
import { Observable, of } from 'rxjs';
import { MinorCode } from '../models/minor-codes.model';
import { MinorCodeCategory, MinorCodeType } from '../enums/minor-codes.enum';

@Injectable({
  providedIn: 'root'
})
export class MinorCodesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getMinorCodeStatusList(): Observable<DropdownData[]> {
    const minorCodesList = Object.entries(MinorCodeType)
      .filter(([key]) => isNaN(Number(key)))
      .map(([key, value]) => ({
        id: value.toString(),
        firstLabel: key,
        secondLabel: null
      }));
    return of(minorCodesList);
  }

  getMinorCodeCategoryList(): Observable<DropdownData[]> {
    const minorCodeCategories = Object.entries(MinorCodeCategory)
      .filter(([key]) => isNaN(Number(key)))
      .map(([key, value]) => ({
        id: value.toString(),
        firstLabel: key,
        secondLabel: null
      }));
    return of(minorCodeCategories);
  }

  readMinorCodes(majorCodeId?: string, jobTypeId?: string): Observable<MinorCode[]> {
    let url = `${this.baseUrl}/minorcode`;
    const params = [];
    if (jobTypeId) params.push(`jobTypeId=${jobTypeId}`);
    if (majorCodeId) params.push(`majorCodeId=${majorCodeId}`);
    if (params.length > 0) url += `?${params.join('&')}`;

    return this.#http.getData(url, { showLoader: true, showMessage: false });
  }

  readMinorCodeById(id: string): Observable<MinorCode> {
    return this.#http.getData(`${this.baseUrl}/minorcode/${id}`, { showLoader: true, showMessage: false });
  }

  createMinorCode(minorCode: Omit<MinorCode, 'id'>): Observable<MinorCode> {
    minorCode.isActive = true;
    return this.#http.postData(`${this.baseUrl}/minorcode`, { showLoader: true, showMessage: true }, minorCode);
  }

  updateMinorCode(minorCode: Omit<MinorCode, 'id'>, id: string): Observable<MinorCode> {
    return this.#http.putData(`${this.baseUrl}/minorcode/${id}`, minorCode, { showLoader: true, showMessage: true });
  }

  deleteMinorCode(id: string): Observable<any> {
    return this.#http.deleteData(`${this.baseUrl}/minorcode/${id}`, { showLoader: true, showMessage: true });
  }
}
